/** Coroa 12×9 do protótipo VIP. O nome não muda de cor. */

const COROA = 'M-6 4V-4l3 3.5L0-5l3 4.5L6-4v8z';
const OURO = '#e6c452';
const PONTA = 'rgba(255,243,196,.9)';

export function mixGray(hex: string, t: number): string {
  const n = parseInt(hex.slice(1), 16);
  const c = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map(v => Math.round(v + (128 - v) * t));
  return '#' + c.map(v => v.toString(16).padStart(2, '0')).join('');
}

export function ouroDaCoroa(morto: boolean): string {
  return morto ? mixGray(OURO, 0.5) : OURO;
}

export function desenharCoroa(
  g: CanvasRenderingContext2D, cx: number, cy: number, ouro: string
): void {
  g.save();
  g.translate(cx, cy);
  const p = new Path2D(COROA);
  g.lineJoin = 'round';
  g.lineWidth = 3;
  g.strokeStyle = 'rgba(0,0,0,.85)';
  g.stroke(p);
  g.fillStyle = ouro;
  g.fill(p);
  g.fillStyle = 'rgba(0,0,0,.28)';
  g.fillRect(-6, 1.6, 12, 2.4);
  g.fillStyle = PONTA;
  for (const [x, y] of [[-6, -4], [0, -5], [6, -4]] as const) {
    g.beginPath();
    g.arc(x, y, 0.95, 0, Math.PI * 2);
    g.fill();
  }
  g.restore();
}

export const COROA_D = COROA;
export const OURO_COROA = OURO;
